/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import * as Popover from '@radix-ui/react-popover';
import CrossIcon from '@bufferapp/ui/Icon/Icons/Cross';

import { useAppSelector, useAppDispatch } from '~/store';
import { queryLimits } from '~/ai/state/aiLimits/thunks';
import { selectGenerateContentLimits } from '~/ai/state/aiLimits/slice';
import { AIButton } from '~/ai/components/AIButton';
import { selectGeneratedIdeas } from '~/ai/state/contentIdeation/slice';
import { Questions } from './Questions';
import { GeneratedIdea } from './GeneratedIdea';
import { UpgradeOptions } from './UpgradeOptions';

import * as Styled from './styles';

/**
 *
 */
const GenerateIdeasButton = () => {
  const [currentIdea, setCurrentIdea] = React.useState<string | null>(null);
  const [showUpgradeOptions, setShowUpgradeOptions] =
    React.useState<boolean>(false);

  const dispatch = useAppDispatch();

  const { generatedIdeas } = useAppSelector((state) =>
    selectGeneratedIdeas(state)
  );

  const { canGenerateContent, limitsLoaded } = useAppSelector((state) =>
    selectGenerateContentLimits(state)
  );

  React.useEffect(() => {
    if (!limitsLoaded || canGenerateContent) return;
    setShowUpgradeOptions(true);
  }, [limitsLoaded]);

  React.useEffect(() => {
    const idea = generatedIdeas.length ? generatedIdeas[0] : null;
    setCurrentIdea(idea);
    dispatch(queryLimits());
  }, [generatedIdeas]);

  const onUpgrade = () => {
    setShowUpgradeOptions(true);
  };

  const onClose = (event) => {
    if (showUpgradeOptions && currentIdea) {
      event.preventDefault();
      event.stopPropagation();
      setShowUpgradeOptions(false);
    }
  };

  const renderContent = () => {
    if (showUpgradeOptions) {
      return <UpgradeOptions />;
    }

    return currentIdea ? (
      <GeneratedIdea onUpgrade={onUpgrade} />
    ) : (
      <Questions />
    );
  };

  return (
    <Popover.Root>
      <Styled.PopoverTrigger>
        <AIButton
          id="generate-ideas-button"
          label="Generate Ideas"
          loading={false}
          disabled={false}
          isBeta
        />
      </Styled.PopoverTrigger>
      <Popover.Portal>
        <Styled.PopoverContent sideOffset={5}>
          <Styled.Background />
          {renderContent()}
          <Styled.PopoverClose aria-label="Close" onClick={onClose}>
            <CrossIcon />
          </Styled.PopoverClose>
          <Styled.PopoverArrow />
        </Styled.PopoverContent>
      </Popover.Portal>
    </Popover.Root>
  );
};

export { GenerateIdeasButton };
